export default __webpack_public_path__ + "static/media/TaskType.1cb3b2a4.svg";